export default __webpack_public_path__ + "static/media/spark_61.b749d574.png";